// Max note images shown before collapsing into a "+N" overflow tile
export const MAX_VISIBLE_IMAGES = 4

// Character count past which a note body is truncated behind "Read more"
export const NOTE_COLLAPSE_CHARS = 120

// Note attachment rules — mirror the backend's server-side validation so bad files are
// rejected before upload (one bad file rejects the whole request; nothing is saved).
export const NOTE_ALLOWED_EXTENSIONS = {
  image: ["jpeg", "jpg", "png", "gif", "webp", "heic", "heif"],
  video: ["mp4", "mov", "webm", "m4v", "avi", "3gp"],
  file: ["pdf"]
}

const MB = 1024 * 1024
export const NOTE_MAX_BYTES = {
  image: 15 * MB,
  video: 50 * MB,
  file: 15 * MB
}
